
import Vue, { PropType } from 'vue'
import { CardSummary } from '@/api/types/user'
import RIcon from '@/components/icons/index.vue'

export default Vue.extend({
  name: 'CardDetils',
  components: {
    RIcon,
  },
  props: {
    cardDetails: {
      type: Object as PropType<CardSummary>,
    },
  },
  computed: {
    last4(): string {
      return `Card ending ••••${this.cardDetails.last_4_digits}`
    },
    expirationDate(): string {
      const { exp_year, exp_month } = this.cardDetails
      return `Expires ${exp_month.padStart(2, '0')}/${exp_year}`
    },
  },
})
